import { useRef, useState } from 'react'
import { ExpandableRows, RowsContainer, SeeMore } from './styles'
import { Container, Content, ProgressBar, Row } from './styles'
import useMediaQuery from '../../../../hooks/use-media-query'
import { IoIosArrowDown } from 'react-icons/io'
import { RiArrowUpSFill, RiArrowDownSFill } from 'react-icons/ri'
import { IModule, IProgress } from '../DashboardContent/types'

interface IModulesChartProps {
  progress: IProgress
}

const ModulesChart = (props: IModulesChartProps) => {
  const { rankingModules: modules, lastDayModuleRanking: lastDayModules } = props.progress

  const isDesktop = useMediaQuery('(min-width: 800px)')
  const expandableRef = useRef<HTMLDivElement | null>(null)

  const [isExpanded, setIsExpanded] = useState(false)

  const firstRows = modules.slice(0, 5)
  const lastRows = modules.slice(5, modules.length)

  const compareLastDay = (module: IModule) => {
    const lastDay = lastDayModules.find((lastDay) => lastDay.name === module.name)

    return lastDay?.position >= module.position ? 'up' : 'down'
  }

  const renderRows = (modules: IModule[]) =>
    modules.map((module) => (
      <Row key={module.name}>
        <div className="column-1">
          <p className="number">{module.position + 1}°</p>
          {compareLastDay(module) === 'up' ? (
            <RiArrowUpSFill className="arrow-up" />
          ) : (
            <RiArrowDownSFill className="arrow-down" />
          )}
        </div>

        <div className="column-2">
          <p className="label">{module.name}</p>
          <ProgressBar progress={(module.totalLessonsCompleted / module.totalLessons) * 100} />
        </div>

        <div className="column-3">
          <p className="text">
            {module.totalLessonsCompleted}/{module.totalLessons}
          </p>
        </div>
      </Row>
    ))

  return (
    <Container>
      <Content>
        <RowsContainer>
          {renderRows(firstRows)}
          <ExpandableRows
            ref={expandableRef}
            isExpanded={isExpanded}
            fullHeight={expandableRef.current?.scrollHeight}
          >
            {renderRows(lastRows)}
          </ExpandableRows>
        </RowsContainer>
      </Content>
      {isDesktop === false && modules.length > 5 && (
        <SeeMore isExpanded={isExpanded} onClick={() => setIsExpanded((state) => !state)}>
          {isExpanded ? 'Ver Menos' : 'Ver Mais'} <IoIosArrowDown className="arrow" />
        </SeeMore>
      )}
    </Container>
  )
}

export default ModulesChart
